import React, { useState, useEffect } from "react";
import DataTable from "../../components/DataTable";
import SnackbarAlert from "../../components/SnackbarAlert";
import { Box, TextField, Tooltip, Typography, Button, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { webEndPoint } from '../../constants/globalConstants';
import { makeRequest } from "../../services/api";
export default function ColorMasterPage() {
    const [datasource, setDatasource] = useState([]);
    const [search, setSearch] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [editState, setEditState] = useState(null);
    const [colorName, setColorName] = useState("");
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        fetchstates();
    }, []);
    const fetchstates = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "colors";
            const response = await makeRequest("get", url);
            if (response) {
                setDatasource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const openAddModal = () => {
        setEditState(null);
        setColorName("");
        setOpenModal(true);
    };
    const handleEdit = (color) => {
        setEditState(color);
        setColorName(color.color_name);
        setOpenModal(true);
    };
    const handleClose = () => {
        setOpenModal(false);
        setColorName("");
    };
    const handleSave = async () => {
        if (!colorName.trim()) {
            setMessage("Color Name Required");
            setSnackbar(true);
            return;
        }
        setLoading(true);
        try {
            if (editState) {
                const colorEditData = {
                    color_name: colorName,
                    image_url: ""
                };
                try {
                    let url = webEndPoint + "colors/" + editState.rfId;
                    const response = await makeRequest("put", url, colorEditData);
                    if (response) {
                        setLoading(false);
                        setMessage("Color Updated Successfully");
                    }
                } catch (err) {
                    if (err?.message) {
                        setMessage(err.message);
                    } else {
                        setMessage("Something went wrong");
                    }
                } finally {
                    setLoading(false);
                }
            } else {
                const colorAddData = {
                    color_name: colorName,
                    image_url: ""
                };
                try {
                    let url = webEndPoint + "colors";
                    const response = await makeRequest("post", url, colorAddData);
                    if (response) {
                        setLoading(false);
                        setMessage("Color Added Successfully");
                    }
                } catch (err) {
                    if (err?.message) {
                        setMessage(err.message);
                    } else {
                        setMessage("Something went wrong");
                    }
                } finally {
                    setLoading(false);
                }
            }
            fetchstates();
            setSnackbar(true);
            setOpenModal(false);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const filteredState = datasource?.filter((d) =>
        d?.color_name?.toLowerCase().includes(search?.toLowerCase())
    );
    const columns = ["S.No", "Color Name", "Action"];
    const rows = filteredState?.map((color, index) => [index + 1, color.color_name,
    <Box>
        <Tooltip title="Edit Color Name">
            <Button variant="contained" color="primary" onClick={() => handleEdit(color)}>Edit</Button>
        </Tooltip>
    </Box>
    ]);
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 500 }}>Color Master</Typography>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "100%", }}>
                <TextField label="Search Color" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "70%", md: 600 } }} />
                <Button variant="contained" startIcon={<AddIcon />} onClick={openAddModal} sx={{ width: { xs: "100%", sm: "auto" }, }}>Add Color</Button>
            </Box>
            <DataTable columns={columns} rows={rows} />
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
            <Dialog open={openModal} onClose={handleClose} fullWidth maxWidth="sm">
                <DialogTitle> {editState ? "Edit Color" : "Add Color"}</DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    <TextField label="Color" value={colorName} onChange={(e) => setColorName(e.target.value)} sx={{ mt: 2 }} fullWidth />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" onClick={handleSave}>Save</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}